import { Box } from "@mui/material";
import { textLikeLinkStyles } from "./styles";

export const TextLikeLink = ({ children }: { children?: JSX.Element | null }) => (
  <Box sx={textLikeLinkStyles}>{children}</Box>
);
